let configElements: NodeListOf<HTMLElement> = document.getElementsByName('vizportal-config');
let configElement: HTMLElement = configElements[0];
BuildId = configElement.getAttribute('data-buildId');
StaticAssetsUrlPrefix = configElement.getAttribute('data-staticAssetsUrlPrefix');

export = {};
